import React from 'react';
import './MediaAssetInspector.css';

function MediaAssetInspector({ 
  func, 
  index, 
  onUpdate,
  isPhotoPickerOpen,
  setIsPhotoPickerOpen,
  photoPickerPosition,
  setPhotoPickerPosition,
  setActivePhotoPreview,
  bringToFront
}) {
  const handleChange = (key, value) => {
    console.log('MediaAssetInspector - handleChange:', { key, value });
    const newProps = {
      ...func.props,
      [key]: value
    };
    console.log('MediaAssetInspector - New props:', newProps);
    onUpdate(index, newProps);
  };

  const handlePreviewClick = (e) => {
    console.log('Media preview clicked');
    // Only store the index - no handler function
    setActivePhotoPreview({ index });
    setIsPhotoPickerOpen(true);
    bringToFront('photoPicker');
    e.stopPropagation();
  };

  return (
    <div className="media-asset-inspector">
      <div 
        className="media-preview"
        onClick={handlePreviewClick}
        title="Click to change photo"
      >
        {func.props.src ? (
          func.props.src.toLowerCase().endsWith('.mp4') ? (
            <video 
              src={func.props.src}
              className="preview-media"
              autoPlay
              muted
              loop
            />
          ) : (
            <img 
              src={func.props.src}
              alt="Media preview"
              className="preview-media"
            />
          )
        ) : (
          <div className="empty-preview">
            Click to select media
          </div>
        )}
      </div>

      <div className="input-group">
        <label>Media Source URL</label>
        <input
          type="text"
          value={func.props.src || ''}
          onChange={(e) => handleChange('src', e.target.value)}
          placeholder="Enter media URL (image or video)"
          className="full-width-input"
        />
      </div>
    </div>
  );
}

export default MediaAssetInspector;